import { useWindowSize } from './useWindowSize'

const useDeviceType = () => {
	const { width } = useWindowSize()
	const isMobile = width < 768
	const isTablet = width >= 768 && width < 1200
	const userDevice = isMobile ? 'mobile' : isTablet ? 'tablet' : 'desktop'
	return userDevice
}

export default useDeviceType
